<!-- KPI CARDS -->
<div class="kpi-grid" [class.loading-opacity]="isLoading">
  <div class="kpi-card red" (click)="onFilterAndRedirect('Active')" style="cursor:pointer;">
    <div class="kpi-label">{{ currentMode === 'Products' ? 'Total Products' : 'Total NDCs' }}</div>
    <div class="kpi-value">{{activeCount | number}}</div>
    <div class="kpi-sub">Records in database</div>
  </div>
  <div class="kpi-card yellow" (click)="onFilterAndRedirect('Current')" style="cursor:pointer;">
    <div class="kpi-label">Active in Shortages</div>
    <div class="kpi-value">{{activeInShortagesCount | number}}</div>
    <div class="kpi-sub">Current status shortages</div>
  </div>
  <div class="kpi-card amb" (click)="onFilterAndRedirect('Discontinued')" style="cursor:pointer;">
    <div class="kpi-label">Approved Discontinuations</div>
    <div class="kpi-value">{{discontinuedCount | number}}</div>
    <div class="kpi-sub">Supply risks (Approved)</div>
  </div>
  <div class="kpi-card grn" (click)="onFilterAndRedirect('Resolved')" style="cursor:pointer;">
    <div class="kpi-label">Resolved (Approved)</div>
    <div class="kpi-value">{{resolvedCount | number}}</div>
    <div class="kpi-sub">Successfully restored supply</div>
  </div>
  <div class="kpi-card blu" (click)="onFilterAndRedirect('New')" style="cursor:pointer;">
    <div class="kpi-label">New This Month</div>
    <div class="kpi-value">{{newThisMonthCount | number}}</div>
    <div class="kpi-sub">Discovered in {{currentMonthYear}}</div>
  </div>
</div>

<!-- GRAPHS -->
<div class="grid-2">
  <div class="card">
    <div class="card-title">Monthly Shortage Trend</div>
    <div class="chart-wrapper">
      <canvas id="monthlyChart"></canvas>
    </div>
  </div>
  <div class="card">
    <div class="card-title">Shortage Status Distribution</div>
    <div class="chart-wrapper">
      <canvas id="statusChart"></canvas>
    </div>
  </div>
</div>

<div class="grid-2">
  <div class="card">
    <div class="card-title">Top Therapeutic Categories</div>
    <div class="chart-wrapper">
      <canvas id="categoryChart"></canvas>
    </div>
  </div>
  <div class="card">
    <div class="card-title">Update Activity</div>
    <div class="chart-wrapper">
      <canvas id="activityChart"></canvas>
    </div>
  </div>
</div>

<div class="grid-1">
  <div class="card">
    <div class="card-title">Shortage Distribution by Route of Administration</div>
    <div class="chart-wrapper" style="height: 300px;">
      <canvas id="routeChart"></canvas>
    </div>
  </div>
</div>

<div *ngIf="isLoading" style="text-align: center; padding: 20px;">
  <span class="loader-sm"></span>
  <div style="font-size: 12px; color: var(--text-muted); margin-top: 8px;">Updating counts...</div>
</div>